import React, { forwardRef } from "react";
import Search from "../../search/Search";
import { ReverseThemeProvider } from "../../../theme/ThemeProvider";
import { useNxTranslation } from "../../../i18n";
import { StyledQuickFind } from "./QuickFind.style";
import translationEN from "../locales/translation-en.json";
import translationFR from "../locales/translation-fr.json";
const QuickFind = forwardRef(function QuickFind({ id, "data-insights": insightsAttr, onSearch, quickFindPosition, onKeyDown }, ref) {
    const { t, nxI18n } = useNxTranslation();
    nxI18n.addResources("en", "actionMenu", translationEN);
    nxI18n.addResources("fr", "actionMenu", translationFR);
    if (!onSearch) {
        return null;
    }
    const label = t("quickFind", { ns: "actionMenu" });
    return (React.createElement(StyledQuickFind, { onKeyDown: onKeyDown, "$position": quickFindPosition },
        React.createElement(ReverseThemeProvider, null,
            React.createElement(Search, { ref: ref, id: id, "data-insights": insightsAttr, onSearch: onSearch, placeholder: label, "aria-label": label }))));
});
export default QuickFind;
//# sourceMappingURL=QuickFind.js.map